module.exports = __webpack_public_path__ + "static/media/Kept - o1.908954c9.png";